import LayoutWrapper from '@mshops-components-library/layout-wrapper';
import withLayoutWrapper from '../../adapters/withLayoutWrapper';

export default withLayoutWrapper(LayoutWrapper);
